import axios from 'axios';

export default {
    create(data) {
        var options = {
            method: 'POST',
            url: window.apiUrl + '/cloudinary',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    sendToCloudinary(data) {
        var options = {
            method: 'POST',
            url: window.apiUrl + '/send-project-to-cloudinary',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getAssetsForUser(id) {
        var options = {
            method: 'GET',
            url: window.apiUrl + '/cloudinary-user/' + id,            
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/cloudinary/index.js